import React, { useEffect } from 'react';

function Toast({ message, type = 'error', onClose, duration = 5000 }) {
  useEffect(() => {
    if (duration > 0) {
      const timer = setTimeout(() => {
        onClose();
      }, duration);
      return () => clearTimeout(timer);
    }
  }, [duration, onClose]);

  return (
    <div className={`toast-notification toast-notification-${type}`} role="alert">
      <div className="toast-notification-content">
        <div className="toast-notification-icon">
          {type === 'success' && <i className="bi bi-check-circle-fill"></i>}
          {type === 'error' && <i className="bi bi-exclamation-circle-fill"></i>}
          {type === 'info' && <i className="bi bi-info-circle-fill"></i>}
          {type === 'warning' && <i className="bi bi-exclamation-triangle-fill"></i>}
        </div>
        <div className="toast-notification-message">{message}</div>
        <button
          className="toast-notification-close"
          onClick={onClose}
          aria-label="Close notification"
        >
          <i className="bi bi-x-lg"></i>
        </button>
      </div>
    </div>
  );
}

export default Toast;
